import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withState, compose } from 'recompose';

import reportBlockedVideoAction from 'actions/reportBlockedVideo';
import s from './ReportBlockedVideo.css';

// eslint-disable-next-line no-shadow
const ReportBlockedVideo = ({ url, reportBlockedVideo, status, setStatus }) => {
  const buttonText = {
    not_clicked: 'Report as Blocked',
    sending_request: 'Sending Report...',
    request_sent: 'Report Sent',
  };
  const notClicked = status === 'not_clicked';
  return (
    <div className={s.container}>
      {notClicked && 'Video Unavailable? '}
      <span
        className={cn({ [s.link]: notClicked, [s.text]: !notClicked })}
        role="button"
        tabIndex={0}
        onClick={async () => {
          if (notClicked) {
            setStatus('sending_request');
            await reportBlockedVideo(url);
            setStatus('request_sent');
          }
        }}
      >
        {buttonText[status]}
      </span>
    </div>
  );
};

ReportBlockedVideo.propTypes = {
  url: PropTypes.string.isRequired,
  reportBlockedVideo: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  setStatus: PropTypes.func.isRequired,
};

export default compose(
  connect(null, d =>
    bindActionCreators({ reportBlockedVideo: reportBlockedVideoAction }, d),
  ),
  withState('status', 'setStatus', 'not_clicked'),
)(ReportBlockedVideo);
